// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"0bd0b96b","151":"e30d5c1e","197":"6a92fd31","735":"17fcec81"}[chunkId] + ".chunk.js";
};